import { render } from "./homebanner-two.vue?vue&type=template&id=c5187ec2"
import script from "./homebanner-two.vue?vue&type=script&lang=js"
export * from "./homebanner-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__